module.exports = __webpack_public_path__ + "img/icon_map_wrzb.6e871d98.png";